import { render, staticRenderFns } from "./SharedSpecimenReport.vue?vue&type=template&id=09b7bf94"
import script from "./SharedSpecimenReport.vue?vue&type=script&lang=js"
export * from "./SharedSpecimenReport.vue?vue&type=script&lang=js"
import style0 from "./SharedSpecimenReport.vue?vue&type=style&index=0&id=09b7bf94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports